import { PlanComparison } from "@/components/PlanComparison";

export default function Pricing() {
  return (
    <div className="max-w-6xl mx-auto">
      <PlanComparison
        mode="auth"
        title="Vælg jeres plan"
        subtitle="Opgradér når som helst. Priser i DKK inkl. moms."
      />
    </div>
  );
}
